import { Sparkles, CarTaxiFront, ReceiptText, KeyRound, ShieldCheck, ConciergeBell } from "lucide-react";
import { useLanguage } from "../i18n/LanguageContext";
import { Reveal, Eyebrow } from "./Reveal";

export const Services = () => {
  const { t } = useLanguage();

  const services = [
    { icon: Sparkles, title: t.svc_cleaning_t, desc: t.svc_cleaning_d, testid: "vip-service-cleaning" },
    { icon: CarTaxiFront, title: t.svc_transport_t, desc: t.svc_transport_d, testid: "vip-service-transport" },
    { icon: ReceiptText, title: t.svc_bills_t, desc: t.svc_bills_d, testid: "vip-service-bills" },
    { icon: KeyRound, title: t.svc_cars_t, desc: t.svc_cars_d, testid: "vip-service-cars" },
    { icon: ShieldCheck, title: t.svc_security_t, desc: t.svc_security_d, testid: "vip-service-security" },
    { icon: ConciergeBell, title: t.svc_more_t, desc: t.svc_more_d, testid: "vip-service-more" },
  ];

  return (
    <section id="services" data-testid="services-section" className="relative py-28 sm:py-36 bg-[#050505] overflow-hidden">
      <div
        className="absolute inset-0 opacity-[0.07] pointer-events-none bg-cover bg-center"
        style={{ backgroundImage: "url(/images/villa-gate.png)" }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-[#050505] via-transparent to-[#050505] pointer-events-none" />

      <div className="relative max-w-7xl mx-auto px-5 sm:px-8">
        <Reveal>
          <Eyebrow>{t.services_eyebrow}</Eyebrow>
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl text-[#F3E5AB] max-w-2xl leading-tight">
            {t.services_title}
          </h2>
          <p className="mt-5 max-w-2xl text-[#C7BFA7] font-light leading-relaxed text-base sm:text-lg">
            {t.services_sub}
          </p>
        </Reveal>

        <div className="mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {services.map((s, i) => (
            <Reveal key={s.testid} delay={(i % 3) * 0.1}>
              <div
                data-testid={s.testid}
                className="group h-full p-8 bg-[#0A0A0A]/90 backdrop-blur-sm border border-[rgba(197,160,89,0.18)] hover:border-[rgba(197,160,89,0.5)] hover:-translate-y-1 transition-all duration-500"
              >
                <s.icon size={26} strokeWidth={1.2} className="text-[#C5A059]" />
                <h3 className="mt-5 font-serif text-xl text-[#EBD5B3]">{s.title}</h3>
                <p className="mt-3 text-sm text-[#9C9488] font-light leading-relaxed">{s.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
